// Booking Type IDs - matches booking_types table in database
export const BOOKING_TYPE_IDS = {
  ON_ROAD: 1, // Roadshow booking (on_road)
  ON_SITE: 2, // On-site booking (on_site) - default for private/corporate
} as const;

// Booking Type Names
export const BOOKING_TYPES = {
  ON_ROAD: "on_road",
  ON_SITE: "on_site",
} as const;

// Helper function to get booking type ID from string
export function getBookingTypeId(
  bookingType?: "private" | "corporate" | "roadshow",
): number {
  if (bookingType === "roadshow") {
    return BOOKING_TYPE_IDS.ON_ROAD;
  }
  return BOOKING_TYPE_IDS.ON_SITE; // Default to on-site for private/corporate
}

// Customer Booking Types (used in UI for customer categorization)
export const CUSTOMER_BOOKING_TYPES = {
  PRIVATE: "private",
  CORPORATE: "corporate",
} as const;

// Type definitions
export type BookingTypeId =
  (typeof BOOKING_TYPE_IDS)[keyof typeof BOOKING_TYPE_IDS];
export type BookingTypeName =
  (typeof BOOKING_TYPES)[keyof typeof BOOKING_TYPES];
export type CustomerBookingType =
  (typeof CUSTOMER_BOOKING_TYPES)[keyof typeof CUSTOMER_BOOKING_TYPES];

// Helper functions for checking customer booking types
export const isPrivateBooking = (type: string): boolean => {
  return type === CUSTOMER_BOOKING_TYPES.PRIVATE;
};

export const isCorporateBooking = (type: string): boolean => {
  return type === CUSTOMER_BOOKING_TYPES.CORPORATE;
};
